module.exports = __webpack_public_path__ + "img/logo-user.c79e1f4.png";